var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page-icon"},[_c('b-icon',{attrs:{"icon":"power-plug"}}),_vm._m(0),_c('div',{staticClass:"error-page-action"},[_c('b-button',{attrs:{"type":"is-link","tag":"router-link","to":"/Home"}},[_vm._v(" Ana Sayfa ")])],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page-caption"},[_c('h1',[_vm._v("404 - Sayfa Bulunamadı")])])
}]

export { render, staticRenderFns }